/**
 * Per-TAB identity for designer-live origin suppression. Deliberately NOT the X-ClientId
 * header (that carries window.userInfo.id — the USER id — so keying suppression on it
 * would hide a user's changes from their own other tabs). The axios interceptor stamps
 * this on every request as X-Designer-Client-Id; the SSE stream subscribes with the same
 * value, so a tab never gets its own mutations echoed back.
 */
export const DESIGNER_LIVE_CLIENT_ID: string =
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `dtab-${Math.floor(performance.now())}-${Math.floor(Math.random() * 1e9)}`;

/**
 * The one header name every transport must stamp. KOA-18196: the axios interceptor was
 * the ONLY sender — any mutation issued through raw fetch (the workflow-screen wizard's
 * streaming save) published with a null origin, so the hub suppressed nobody and the
 * saving tab received its own workflowScreens.changed as a "someone updated…" toast.
 * Every header builder (axios interceptor, StreamingHelperService, mcp-tools helpers)
 * must reference THIS constant so the senders cannot drift.
 */
export const DESIGNER_LIVE_CLIENT_ID_HEADER: string = "X-Designer-Client-Id";
